var _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    rx: 5,
    fill: "url(#patternLU)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "patternLU",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_8917_2526",
    transform: "translate(-0.333333) scale(0.00574713)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_8917_2526",
    width: 290,
    height: 174,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASIAAACuCAIAAAAd2Zf2AAAEFklEQVR4Ae3VQY3DQBBFwb6HRhgMAfPM0bwsI7AhTFC8W618zpdK83rnXYePAIFUYNJf9+MECLzrkJl/5gRyAZnlxM45AZnJjEAuILOc2C0nIDOZEcgFZJYTu+UEZCYzArmAzHJit5yAzGRGIBeQWU7slhOQmcwI5AIyy4ndcgIykxmBXEBmObFbTkBmMiOQC8gsJ3bLCchMZgRyAZnlxG45AZnJjEAuILOc2C0nIDOZEcgFZJYTu+UEZCYzArmAzHJit5yAzGRGIBeQWU7slhOQmcwI5AIyy4ndcgIykxmBXEBmObFbTkBmMiOQC8gsJ3bLCchMZgRyAZnlxG45AZnJjEAuILOc2C0nIDOZEcgFZJYTu+UEZCYzArmAzHJit5yAzGRGIBeQWU7slhOQmcwI5AIyy4ndcgIykxmBXEBmObFbTkBmMiOQC8gsJ3bLCchMZgRyAZnlxG45AZnJjEAuILOc2C0nIDOZEcgFZJYTu+UEZCYzArnAPJ+vjwCBVGC2PwIEYgGZxcB+nsDeMvMKCOQCMsuJDRCQmTdAIBeQWU5sgIDMvAECuYDMcmIDBGTmDRDIBWSWExsgIDNvgEAuILOc2AABmXkDBHIBmeXEBgjIzBsgkAvILCc2QEBm3gCBXEBmObEBAjLzBgjkAjLLiQ0QkJk3QCAXkFlObICAzLwBArmAzHJiAwRk5g0QyAVklhMbICAzb4BALiCznNgAAZl5AwRyAZnlxAYIyMwbIJALyCwnNkBAZt4AgVxAZjmxAQIy8wYI5AIyy4kNEJCZN0AgF5BZTmyAgMy8AQK5gMxyYgMEZOYNEMgFZJYTGyAgM2+AQC4gs5zYAAGZeQMEcgGZ5cQGCMjMGyCQC8gsJzZAQGbeAIFcQGY5sQECMvMGCOQCMsuJDRCQmTdAIBeQWU5sgIDMvAECuYDMcmIDBGTmDRDIBWSWExsgMPO7fAQItAJz3j4CBFqB9tc1TIDAeY/MCBDIBfIBx4wAAZkRIJAL5AMuGQECMiNAIBfIB1wyAgRkRoBALpAPuGQECMiMAIFcIB9wyQgQkBkBArlAPuCSESAgMwIEcoF8wCUjQEBmBAjkAvmAS0aAgMwIEMgF8gGXjAABmREgkAvkAy4ZAQIyI0AgF8gHXDICBGRGgEAukA+4ZAQIyIwAgVwgH3DJCBCQGQECuUA+4JIRICAzAgRygXzAJSNAQGYECOQC+YBLRoCAzAgQyAXyAZeMAAGZESCQC+QDLhkBAjIjQCAXyAdcMgIEZEaAQC6QD7hkBAjIjACBXCAfcMkIEJAZAQK5QD7gkhEgIDMCBHKBfMAlI0BAZgQI5AL5gEtGgIDMCBDIBfIBl4wAAZkRIJAL5AMuGQECMiNAIBfIB1wyAgRkRoBALfAHscZCCZuZXFcAAAAASUVORK5CYII="
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLu);
export default __webpack_public_path__ + "static/media/LU.65bd7e2ff53727aaa51fe107b1bd5b38.svg";
export { ForwardRef as ReactComponent };